import { useEffect, useRef } from 'react';
import { User as FirebaseUser, getIdToken } from 'firebase/auth';

interface UseSessionManagerProps {
  user: FirebaseUser | null;
}

export const useSessionManager = ({ user }: UseSessionManagerProps) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (user) {
      // Função para renovar o token
      const refreshToken = async () => {
        try {
          const token = await getIdToken(user, true); // Force refresh
          console.log('🔄 Token renovado automaticamente');
          
          // Verificar se o token ainda é válido
          if (token) {
            // Agendar próxima renovação em 45 minutos
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(refreshToken, 45 * 60 * 1000);
          }
        } catch (error) {
          console.error('Erro ao renovar token:', error);
          // Tentar novamente em 5 minutos se houver erro
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(refreshToken, 5 * 60 * 1000);
        }
      };

      // Renovar token imediatamente
      refreshToken();

      // Configurar renovação automática a cada 45 minutos
      intervalRef.current = setInterval(refreshToken, 45 * 60 * 1000);

      // Cleanup function
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
      };
    } else {
      // Limpar intervals se não há usuário
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }
  }, [user]);

  // Cleanup quando o componente for desmontado
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};
